import { css } from 'styled-components';

import { FontSize } from '~lib/styles/Theme/fontSize';
import { KeysOf } from '~types/common';

import { TypographyKey } from '.';

export function getFontStyle(typography: TypographyKey) {
  const lineHeight = typography.match(/120/gi) ? 'default' : 'high';
  const fontWeight = typography.match(/midium/gi) ? 'normal' : 'bold';
  const fontSizeKey = typography.split('_')[1].toUpperCase() as KeysOf<FontSize>;

  return css`
    line-height: ${({ theme }) => theme.lineHeight[lineHeight]};
    font-weight: ${({ theme }) => theme.fontWeight[fontWeight]};
    font-size: ${({ theme }) => theme.fontSize[fontSizeKey]};
  `;
}
